import { BrowserRouter } from "react-router-dom";
import ReactDOM from 'react-dom/client';

import { I18nextProvider } from "react-i18next";

import Router from "./router/";
import i18n from "./translation";
import StepsContext from "./context/UserContext";
import React from "react";
import { Config } from '@forgerock/javascript-sdk';

import { AM_URL, APP_URL, JOURNEY_LOGIN, REALM_PATH, FR_API_TIMEOUT } from "./constants";
import { RequestObj, Action } from "./common/types";




const addHeadersMiddleware = (
  req: RequestObj,
  action: Action,
  next: () => RequestObj
): void => {
  switch (action.type) {
    case 'AUTHENTICATE':
      const headers_auth = req.init.headers as Headers;
      headers_auth.append('Global-Channel-Id', '');
      // headers_auth.append('X-Env-Id', 'UAT1');
      break;
  }
  next();
};


Config.set({
  middleware: [
    addHeadersMiddleware
  ],
  redirectUri: `${APP_URL}/callback`,
  serverConfig: {
    baseUrl: AM_URL!,
    timeout: FR_API_TIMEOUT,
  },
  realmPath: REALM_PATH,
  tree: JOURNEY_LOGIN,
}
);


const App = () => {
  document.body.dir = i18n.dir();

  return (
    <>
      <StepsContext>
        <BrowserRouter>
          <I18nextProvider i18n={i18n}>
            <Router />
          </I18nextProvider>
        </BrowserRouter>
      </StepsContext>
    </>
  )
};

let root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);